import { ActionTypes } from '../../constants';

class ValidationActions {
  static setValidationData(validationData) {
    return {
      type: ActionTypes.SET_VALIDATION_DATA,
      payload: {
        validationData,
      },
    };
  }
}

export default ValidationActions;